/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 给项目的评论点赞或者取消
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PraiseParams {
  constructor(public commentId: string) {}
}

export default async function (
  params: PraiseParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.CommentLikeDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/member/comment/praise`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
